<template>
    <div class="fw-member">
        <div class="member-bt">
            <span class="bty">
                MEMBER | 会员
            </span>
            <div class="mbmd">
                <span class="mdname"><i class="el-icon-s-shop" style="color:#CDCDCD;font-size: 25px;margin-right: 8px"/>{{member.deptName}}</span>
                <img v-if="member.headPortrait" :src="member.headPortrait" class="touxiang"/>
                <img v-if="!member.headPortrait&&member.sex==1" src="./../../assets/nan.png" class="touxiang"/>
                <img v-if="!member.headPortrait&&member.sex==2" src="./../../assets/nv.png" class="touxiang"/>
                <span class="mbname">{{member.memberName}}</span>
            </div>
            <div class="mbzxmenu">
                <div class="mbzxmenu-item" @click="tombcards">
                    <van-icon name="vip-card-o" class="hyzximg"/>
                    <span>会员卡</span>
                </div>
                <div class="mbzxmenu-item" @click="tombtc">
                    <van-icon name="qr" class="hyzximg"/>
                    <span>套餐管理</span>
                </div>
                <div class="mbzxmenu-item" @click="tombxf">
                    <van-icon name="bill-o" class="hyzximg"/>
                    <span>消费记录</span>
                </div>
            </div>
        </div>
        <div class="caozuo">
            <div class="caozuo-item" @click="toMds">
                <span>切换门店</span>
                <i class="el-icon-arrow-right"/>
            </div>
            <div class="caozuo-item" @click="toEdit">
                <span>完善信息</span>
                <i class="el-icon-arrow-right"/>
            </div>
            <div class="caozuo-item" @click="totuichu">
                <span>退出登录</span>
                <i class="el-icon-arrow-right"/>
            </div>
        </div>
        <div class="hyzx">
            <div class="hyzx-s">
                <div class="bian"></div>
                <div class="zhong">
                    <van-icon name="apps-o" color="#D4237A" style="margin-bottom: -8px;"/>
                </div>
                <div class="bian"></div>
            </div>
            <div class="hyzx-x">
                <span class="hy-text">会员中心</span>
            </div>
        </div>

        <van-popup v-model="mdShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false"
                   style="height: 55%;overflow:hidden;padding-bottom: 50px">
             <span class="md-bt">
                    <span>门店列表</span>
                    <i class="el-icon-close" @click="guanbi"></i>
             </span>
            <div class="md-items">
                <div class="md-item" v-for="md in mds">
                    <div class="fw-mduser">
                        <div style="display: flex;flex-direction: row;align-items: center">
                            <i class="el-icon-s-shop" style="font-size: 20px;color:#777777;margin-right: 5px"/>
                            <span>{{md.deptName}}</span>
                        </div>
                        <span class="jinruEmp1" v-if="md.selected">当前选中</span>
                        <span class="jinruEmp" v-if="!md.selected" @click="jinruUser(md)">进入</span>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {delCookie, getCookie, setCookie} from "../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                fwUser: {},
                deptId: '',
                token: '',
                member: {},
                mdShow: false,
                mds: [],
            };
        },
        async created() {
            document.title = "会员中心"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            if (!this.fwUser) {
                this.$router.push('/members')
            } else {
                if (this.fwUser.userType != 5) {
                    this.$router.push('/members')
                }
            }
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.userType = this.fwUser.userType
            this.getMember()
        },
        methods: {
            async getMember() {
                let data = {
                    token: this.token
                }
                let res = await this.$get("/fw/getFwTyMember", data)
                this.member = res.member
            },
            tombcards() {
                this.$router.push('/myCards')
            },
            tombxf() {
                this.$router.push('/myMdCmp')
            },
            tombtc() {
                this.$router.push('/myMdTc')
            },

            toEdit() {
                this.$router.push('/editMb')
            },

            toMds() {
                this.getMemberMds()
                this.mdShow = true
            },
            guanbi() {
                this.mdShow = false
            },
            async jinruUser(item) {
                let data = {
                    id: item.id,
                    registerId: item.registerId,
                    deptName: item.deptName,
                    memberName: item.memberName,
                    phone: item.phone,
                }
                let res = await this.$post("/fw/fwSetMember", data)
                if (res.code == 200) {
                    setCookie('fwUser', JSON.stringify(res.fwUser), 30)
                    this.token = res.fwUser.token
                    this.getMember()
                    this.guanbi()
                }
            },
            async getMemberMds() {
                let data = {
                    token: this.token,
                }
                let res = await this.$get("/fw/getFwMemberDeptList", data)
                this.mds = res.mds
            },

            totuichu() {
                this.$dialog.confirm({
                    title: '提示',
                    message: '确认退出'
                }).then(() => {
                    delCookie('fwUser')
                    this.$router.push('/members')
                }).catch(() => {
                    // on cancel
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .fw-member {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-top: 80px;
        padding-bottom: 49px;
    }

    .member-bt {
        width: 80%;
        margin: auto;
    }

    .bty {
        display: block;
        font-size: 26px;
        font-weight: bold;
        height: 25px;
        line-height: 25px;
        text-align: center;
    }

    .mbmd {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 23px;
    }

    .mbmd .mdname {
        display: flex;
        font-size: 16px;
        line-height: 22px;
    }

    .mbmd .touxiang {
        margin-top: 45px;
        width: 50px;
        height: 50px;
    }

    .mbmd .mbname {
        margin-top: 13px;
        font-size: 14px;
    }

    .mbzxmenu {
        margin-top: 38px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-size: 13px;
    }

    .mbzxmenu-item {
        width: 100px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .hyzximg {
        font-size: 32px;
        margin-bottom: 6px;
    }

    .caozuo {
        width: 90%;
        margin: auto;
        padding-top: 38px;
    }

    .caozuo-item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 5px;
        border-bottom: #dddddd solid 1px;
        font-size: 13px;
        height: 30px;
        line-height: 30px;
        margin-top: 8px;
    }

    .hyzx {
        position: fixed;
        bottom: 0px;
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    .hyzx-s {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .hyzx-s .bian {
        width: 41%;
        border-bottom: #ECECEC solid 2px;
    }

    .hyzx-s .zhong {
        width: 18%;
        border: #ECECEC solid 2px;
        border-bottom: #FFFFFF solid 2px;
        border-top-right-radius: 8px;
        border-top-left-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 5px 5px 0px 5px;
    }

    .hyzx-x {
        margin-top: 15px;
    }

    .hy-text {
        display: block;
        text-align: center;
        height: 30px;
        font-size: 15px;
    }

    .md-bt {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        font-size: 15px;
        border-bottom: #dddddd solid 1px;
        padding: 10px;
    }

    .md-items {
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: auto;
        height: 100%;
        background-color: #FFFFFF;
        padding-top: 12px;
        padding-bottom: 3px;
    }

    .md-item {
        width: 90%;
        padding: 8px 20px;
        font-size: 13px;
        display: flex;
        flex-direction: column;
        background-color: #eeeeee;
        border-radius: 3px;
        margin-bottom: 10px;
    }

    .fw-mduser {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .jinruEmp {
        padding: 3px 8px;
        background-color: #2b94ff;
        border-radius: 3px;
        color: #ffffff;
    }

    .jinruEmp1 {
        padding: 3px 8px;
        border-radius: 3px;
    }

</style>